module.exports = __webpack_public_path__ + "img/6.a397cd01.jpg";